import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import '@/App.css';
import Landing from '@/pages/Landing';
import Login from '@/pages/Login';
import Dashboard from '@/pages/Dashboard';
import { Toaster } from '@/components/ui/sonner';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('mauma_token');
    const userData = localStorage.getItem('mauma_user');
    
    if (token && userData) {
      setUser(JSON.parse(userData));
    }
    setLoading(false);
  }, []);

  const handleLogin = (userData, token) => {
    localStorage.setItem('mauma_token', token);
    localStorage.setItem('mauma_user', JSON.stringify(userData));
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('mauma_token');
    localStorage.removeItem('mauma_user');
    setUser(null);
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-[#FAF8F5] flex items-center justify-center">
        <div className="animate-pulse text-[#C9A961] text-xl font-cormorant">Cargando...</div>
      </div>
    );
  }

  return (
    <div className="App">
      <BrowserRouter basename="/backoffice">
        <Routes>
          {/* Landing page pública */}
          <Route path="/" element={<Landing />} />
          
          {/* Admin routes */}
          <Route
            path="/admin/login"
            element={!user ? <Login onLogin={handleLogin} /> : <Navigate to="/admin" />}
          />
          <Route
            path="/admin/*"
            element={user ? <Dashboard user={user} onLogout={handleLogout} /> : <Navigate to="/admin/login" />}
          />
          
          {/* Redirect old login to new admin login */}
          <Route path="/login" element={<Navigate to="/admin/login" />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;